import React from 'react';
import './recommendedField.scss';

export default function RequiredField(props) {
  return (
    <div className={`gray-box ${props.class}`}> { /* eslint-disable-line */ }
      <p className="label_text">
      RECOMMENDED
      </p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/modules/common/recommendedField.js